import { render, staticRenderFns } from "./veStuCheckNormShow.vue?vue&type=template&id=27b0bed3&scoped=true"
import script from "./veStuCheckNormShow.vue?vue&type=script&lang=js"
export * from "./veStuCheckNormShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0bed3",
  null
  
)

export default component.exports